import React, { useState } from 'react';

interface GalleryProps {
  images: {
    src: string;
    alt: string;
  }[];
}

const Gallery: React.FC<GalleryProps> = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const openLightbox = (index: number) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction: 'prev' | 'next') => {
    if (selectedImage === null) return;
    
    const newIndex = direction === 'next' 
      ? (selectedImage + 1) % images.length
      : (selectedImage - 1 + images.length) % images.length;
    
    setSelectedImage(newIndex);
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {images.map((image, index) => (
          <div 
            key={index}
            className="cursor-pointer rounded-lg transition-shadow duration-300"
            style={{ aspectRatio: '16/9' }}
            onClick={() => openLightbox(index)}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover rounded-lg shadow-md hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
              style={{ aspectRatio: '16/9' }}
            />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 text-white text-xl p-2 hover:bg-white hover:bg-opacity-20 rounded-full"
            onClick={closeLightbox}
          >
            ✕
          </button>
          <button
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-2xl p-4 hover:bg-white hover:bg-opacity-20 rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
          >
            ‹
          </button>
          <img
            src={images[selectedImage].src}
            alt={images[selectedImage].alt}
            className="max-h-[90vh] max-w-[90vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-2xl p-4 hover:bg-white hover:bg-opacity-20 rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
          >
            ›
          </button>
        </div>
      )}
    </>
  );
};

export default Gallery; 